import React, { Fragment } from "react";
import Navbar from "../components/Navbar";
import BlogLanding from "../components/BlogLanding";

const Blog = () => {
  return (
    <Fragment>
      <div className="bg-cream h-screen px-8 py-12 md:px-16 md:py-24">
        <Navbar />
        <BlogLanding />
      </div>
    </Fragment>
  );
};

export default Blog;
// import React, { Fragment } from "react";
// import Navbar from "../components/Navbar";
// import BlogLanding from "../components/BlogLanding";
// import BlogBg from "./../assets/bg/blogBg.jpg";
// import BlogPosts from "../components/BlogPosts";

// const BlogBackground = {
//   backgroundImage: `url(${BlogBg})`,
//   backgroundPosition: "center",
//   backgroundSize: "cover",
//   backgroundRepeat: "no-repeat",
//   backgroundAttachment: "fixed",
// };

// const Blog = () => {
//   return (
//     <Fragment>
//       <div className="px-8 py-6 md:px-16 md:py-8">
//         <Navbar />
//       </div>
//       <div className="h-full lg:h-screen" style={BlogBackground}>
//         <div className="bg-black px-8 py-12 md:px-16 md:py-24 opacity-70 h-full w-full">
//           <BlogLanding />
//         </div>
//       </div>
//       <div>
//         <BlogPosts />
//       </div>
//     </Fragment>
//   );
// };

// export default Blog;
